import fadeOutAudio from "./fade-out-audio";
import { chainedPlaybackFunction } from "./playback";
import stopVideoAfterDelay from "./stop-video-after-delay";

/**
 * Swap between 2 video elements
 *
 * @param {HTMLElement} newVideo Video to start
 * @param {HTMLElement} oldVideo Video to stop
 * @returns {Function} optional chained function to start immediate
 * playback.
 */
export default function switchVideos(newVideo, oldVideo) {
  if (!oldVideo.paused) {
    if (!oldVideo.muted) {
      oldVideo.ontimeupdate = null;
      fadeOutAudio(oldVideo);
    }
    stopVideoAfterDelay(oldVideo);
  }

  return chainedPlaybackFunction(newVideo);
}
